






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'NavigateBack',
})
export default class extends Vue {
  @Prop({ required: true })
  href: string

  @Prop({ required: true })
  label: string
}
